package se.soderbjorn.lunapin.client

/**
 * A relative URL, and this one is final rather than provisional.
 *
 * The server that served this bundle is the server the bundle talks to — that is the
 * whole point of the one process hosting both — so there is no cross-origin request
 * here and no CORS to configure. Naming an absolute origin instead would break the
 * moment the deployment moved, and would need a CORS policy to fix.
 */
actual fun defaultServerUrl(): String = ""
